skyward.base.registerScript("ajaxError", function (skyward, $)
{
    "use strict";
    skyward.ajaxError = skyward.ajaxError || {};
    let invalidSessionDialogOpen = false;

    skyward.ajaxError.processAjaxError = function (event, jqXHR, settings)
    {
        if (settings != null && (settings.suppressErrors === true || typeof settings.suppressErrors === "function" && settings.suppressErrors(jqXHR)))
        {
            return;
        }

        switch (jqXHR.status)
        {
            case 401:
                //Unauthorized
                if (jqXHR.responseText === "Invalid session")
                {
                    // Reload the page so that we get redirected to sign-in from a normal GET request
                    window.location.replace(window.location.href);
                }
                else
                {
                    showForbiddenAccessDialog(jqXHR.responseText);
                }
                break;
            case 403:
                //Forbidden
                var isWorkflowAjaxRequest = settings != null && settings.activityIndicator != null && settings.activityIndicator.isWorkflowAjaxRequest;
                const isInvalidSession = jqXHR.getResponseHeader("X-Forbidden-Reason") === "SessionChanged";

                if (isInvalidSession)
                {
                    // If we have multiple requests outstanding and the user's session changed, don't spam them with popups
                    if (invalidSessionDialogOpen)
                    {
                        break;
                    }
                    invalidSessionDialogOpen = true;
                    showForbiddenAccessDialog(jqXHR.responseText, isWorkflowAjaxRequest).always(() => { invalidSessionDialogOpen = false; });
                }
                else
                {
                    showForbiddenAccessDialog(jqXHR.responseText, isWorkflowAjaxRequest);
                }
                break;
            case 500:
                //Server Error
                const log = skyward.ajaxError.logAjaxError(jqXHR);

                if (log.primaryKey > 0)
                {
                    skyward.modalLayer.showErrorDialog("Internal Server Error", "There was an error processing your request (" + log.primaryKey + "):\n" + log.message);
                }
                else
                {
                    skyward.modalLayer.showErrorDialog("Internal Server Error", "There was an error processing your request:\n" + log.message);
                }

                break;
        }
    };

    skyward.ajaxError.logAjaxError = function (jqXHR)
    {
        var log = { message: "Unknown error.", severity: "", primaryKey: null };
        if (jqXHR.responseText)
        {
            try
            {
                var errorData = JSON.parse(jqXHR.responseText);
                if (errorData !== null)
                {
                    log.message = errorData.message;
                    log.severity = errorData.severity;
                    log.primaryKey = errorData.primaryKey;
                    log.showViewLog = errorData.showViewLog;
                }
            }
            catch (ex)
            {
                log.message = "An additional error occurred while processing the error data.";
                console.warn("Unparsable error data", jqXHR.responseText);
            }
            let exceptionToReport = new window.SkywardException("A server-side error occurred");
            if (log.primaryKey)
            {
                exceptionToReport.details = { primaryKey: log.primaryKey };
            }
            else
            {
                exceptionToReport.details = log;
            }
            skyward.error.reportException(exceptionToReport);
        }
        return log;
    };

    var showForbiddenAccessDialog = function (responseText, isWorkflowAjaxRequest)
    {
        //if there's a workflow popup, pass button param to the call to showCriticalDialog, 
        //make the close button not just close the modal, but also the workflow popup

        var options = null;
        if (isWorkflowAjaxRequest)
        {
            options = { afterClose: skyward.workflow.closeWorkflowPopup };
        }

        return skyward.modalLayer.showErrorDialog("Forbidden Access", responseText ?? "You do not have the correct permissions to perform this task.", options);
    };

    //bootstrap
    $(document).ajaxError(skyward.ajaxError.processAjaxError);

    skyward.events.registerEvents("error",
        {
            dialog: function ()
            {
                var data = $(this).data();
                skyward.modalLayer.showErrorDialog(data.message, data.description);
            }
        });
});